<template>
    <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblDotacoesOrcamentarias"
                :itens="contrato.dotacoesOrcamentarias"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <btn-inserir-dotacao
                            :contrato="contrato"
                            :apostilamento="apostilamento()"
                            @obterDotacoesAtualizadas="
                                $emit('obterDotacoesAtualizadas')
                            "
                            v-if="mostrarBtnInserirDotacao"
                        ></btn-inserir-dotacao>
                    </div>
                </template>
                <template slot="codCCusto" slot-scope="data">
                    <span>{{data.codCCusto}}
                    </span>
                    <app-status class="ml-1"
                        status="PADRÃO"
                        v-if="data.dotacaoPadrao && !contratoPorMedicao"
                    ></app-status>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar-dotacao
                        :dotacao="data"
                        :contrato="contrato"
                        :apostilamento="apostilamento()"
                        v-if="mostrarBtnAtualizarDotacao"
                        @obterDotacoesAtualizadas="
                            $emit('obterDotacoesAtualizadas')
                        "
                    ></btn-atualizar-dotacao>
                    <btn-excluir-dotacao
                        :dotacao="data"
                        :contrato="contrato"
                        :apostilamento="apostilamento()"
                        v-if="mostrarBtnExcluirDotacao(data)"
                        @obterDotacoesAtualizadas="
                            $emit('obterDotacoesAtualizadas')
                        "
                    ></btn-excluir-dotacao>
                    <btn-atualizar-dotacao-padrao
                        :contrato="contrato"
                        :dotacao="data"
                        v-if="mostrarBtnAtualizarDotacaoPadrao(data)"
                        @obterDotacoesAtualizadas="
                            $emit('obterDotacoesAtualizadas')
                        "
                    ></btn-atualizar-dotacao-padrao>
                </template>
            </app-tabela>
        </div>
    </div>
</template>

<script>
import BtnAtualizarDotacao from './BtnAtualizarDotacao'
import BtnInserirDotacao from './BtnInserirDotacao'
import BtnExcluirDotacao from './BtnExcluirDotacao'
import BtnAtualizarDotacaoPadrao from './BtnAtualizarDotacaoPadrao.vue'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    components: {
        BtnAtualizarDotacao,
        BtnInserirDotacao,
        BtnExcluirDotacao,
        BtnAtualizarDotacaoPadrao
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            dotacao: null,
            erros: [],
            campos: [
                {
                    key: 'codCCusto',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeCCusto',
                    label: 'Centro de Custo',
                    sortable: true,
                    filterable: true
                },
                // {
                //     key: 'projeto',
                //     label: 'Projeto',
                //     filterable: true,
                //     sortable: true
                // },
                // {
                //     key: 'acao',
                //     label: 'Ação',
                //     filterable: true,
                //     sortable: true
                // },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return (
                this.$temAcessoView('CONT-APOST-02') &&
                this.situacoesVigenteDistribuido()
            )
        },

        contratoElaboracao() {
            return (
                this.$temAcessoView('CONT-ELAB-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivoContratoIniciado() {
            return (
                this.$temAcessoView('CONT-ADITIV-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        mostrarBtnExcluirDotacao(dotacao) {
            let podeExcluir = 
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            
            if (!this.contratoPorMedicao) {
                podeExcluir = podeExcluir && 
                    this.contrato.dotacoesOrcamentarias.length > 1 &&
                    !dotacao.dotacaoPadrao 
            }
            
            return podeExcluir
        },

        mostrarBtnAtualizarDotacaoPadrao(dotacao) {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos() &&
                dotacao.dotacaoPadrao==false && 
                !this.contratoPorMedicao
            )
        }
    },

    created() {},

    computed: {
        mostrarBtnInserirDotacao() {
            return (
                ((this.apostilamento()) ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos() //
            )
        },

        contratoPorMedicao() {
            return this.contrato.idTipoContrato === 1
        },

        mostrarBtnAtualizarDotacao() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        }
    },

    watch: {}
}
</script>
